import { render, staticRenderFns } from "./auth-component.vue?vue&type=template&id=7bd3a63d&scoped=true"
import script from "./auth-component.vue?vue&type=script&lang=ts"
export * from "./auth-component.vue?vue&type=script&lang=ts"
import style0 from "./auth-component.vue?vue&type=style&index=0&id=7bd3a63d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3a63d",
  null
  
)

export default component.exports